import { Box, useTheme } from '@mui/material';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProductContext } from 'src/contexts/ProductContext';

interface ILogoInterface {
  height?: number | string;
  width?: number | string;
}

function Logo(props: ILogoInterface) {
  const { height = 'auto', width = 'auto' } = props;
  const { product } = useContext(ProductContext)
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/home')
  }

  const theme = useTheme();

  return (
    <Box>
      <img src={theme.palette.mode === 'dark' ? product.logoDark : product.logoLight} alt='Logo' height={height} width={width} onClick={handleLogoClick} />
    </Box>
  );
}

export default Logo;
